import type { CollectionItem } from "@/shared/contracts";

/** Read the additive server field while the frozen generated contract catches up.
 * This is display text, not proof of public visibility or a regeneration request.
 */
export function collectionImageUnavailableNote(item: CollectionItem): string | null {
  if (!("image_unavailable_note" in item)) return null;
  const note = item.image_unavailable_note;
  return typeof note === "string" && note.trim() ? note : null;
}
